import { BorderlessAlertTriangleIcon } from '#app/__generated__/components/Icons/BorderlessAlertTriangle.js';
import { ModalTemplateWrapper } from '#app/components/Modals/V2/GlobalModalSystem/ModalTemplateWrapper/ModalTemplateWrapper.js';
import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { useCallback } from 'react';

const MODAL_NAME = 'stripe_verification_exit';

type StripeMoreInformationModalV2Props = {
  readonly isLoading: boolean;
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onContinue: () => void;
};

export const StripeMoreInformationModalV2 = ({
  isLoading,
  isOpen,
  onClose,
  onContinue,
}: StripeMoreInformationModalV2Props) => {
  const { track } = useAnalytics();

  const handleOnContinue = useCallback(() => {
    track('modal', {
      action: 'tapped',
      cta: 'continue',
      modal_name: MODAL_NAME,
    });
    onContinue();
  }, [onContinue, track]);

  const handleOnClose = useCallback(() => {
    track('modal', {
      action: 'tapped',
      cta: 'close',
      modal_name: MODAL_NAME,
    });
    onClose();
  }, [onClose, track]);

  return (
    <ModalTemplateWrapper
      ariaLabel="More information required"
      ctaOptions={{
        primaryCTA: {
          handleOnClick: handleOnContinue,
          isLoading,
          label: 'Continue',
          variant: 'V2Primary',
        },
        secondaryCTA: {
          handleOnClick: handleOnClose,
          label: 'Close',
        },
      }}
      desktopModalSize="lg"
      headerText="More information required"
      icon={<BorderlessAlertTriangleIcon />}
      isOpen={isOpen}
      onClose={handleOnClose}
      subheaderText="Ensure that you fill out all information that Stripe asks for. Click
      continue to complete on stripe.com"
    />
  );
};
